type JSONCSVValue = {
  col_name: string;
  value: string;
};

type CSVValue = {
  colName: string;
  value: string;
};

const fromJSON = (jsonCSV: JSONCSVValue): CSVValue => ({
  colName: jsonCSV.col_name,
  value: jsonCSV.value,
});

export default CSVValue;

export { fromJSON };
